import theme from '@/theme';
import styled from '@emotion/styled';

const StyledTable = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    border: 1px solid ${theme.colors.black[300]};
    background-color: ${theme.colors.white};
    overflow: hidden;

    & > tr {
        border-bottom: 1px solid ${theme.colors.black[300]};

        &:last-of-type {
            border-bottom: none;
        }
    }
`;

export const Table = ({ children }: { children: React.ReactNode }) => {
    return <StyledTable>{children}</StyledTable>;
};
